<template>
  <div :class="`page-wrapper max-width-${maxWidth} ${wrapperClass}`">
    <div class="flex-between mobile-none tablet-none">
      <div class="flex-start">
        <Button
          variant="outline-complementary"
          :justIcon="backIcon"
          contentClass="button__just-icon"
          class="margin-left-16"
          @click="goToBaseRoute"
        />
        <slot name="title-area">
          <div
            class="color-complementary-400 font-size-16 direction--rtl flex-start"
            v-html="generateTitle"
          />
        </slot>
      </div>
      <slot name="left-header"></slot>
    </div>
    <div class="page-wrapper__header desktop-none">
      <div class="header__right-box" @click="goToBaseRoute">
        <mdicon :name="backIcon" size="24" />
      </div>
      <div class="header__title" v-html="title" />
    </div>

    <div :class="`page-wrapper__body ${bodyClass}`">
      <b-row class="margin-0">
        <b-col cols="12" class="padding-0 desktop-none">
          <slot name="left-header"></slot>
        </b-col>
        <b-col cols="12" class="padding-0">
          <slot name="default"></slot>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import { Button } from "@/components/re-design/forms";
import { mapGetters } from "vuex";
import { goToRoute } from "@/shared/utils";

export default {
  components: { Button },
  props: {
    backIcon: {
      type: String,
      default: "close",
    },
    wrapperClass: {
      type: String,
      default: "",
    },
    bodyClass: {
      type: String,
      default: "",
    },
    maxWidth: {
      type: [Number, String],
      default: 700,
    },
    handleBack: {
      type: Function,
      default: null,
    },
    title: {
      type: String,
      default: "",
    },
  },
  computed: {
    ...mapGetters(["mobileHeaderBaseRoute", "mobileHeaderTitleText"]),
    generateTitle() {
      return this.title || this.mobileHeaderTitleText || this.$route.meta.label;
    },
  },
  methods: {
    goToBaseRoute() {
      if (this.handleBack) {
        this.handleBack();
        return;
      }
      if (this.mobileHeaderBaseRoute) {
        goToRoute(this.mobileHeaderBaseRoute, {}, {}, false);
      } else {
        this.$router.back();
      }
    },
  },
};
</script>
